export var ConnectionType;
(function (ConnectionType) {
    ConnectionType[ConnectionType["WebTransport"] = 0] = "WebTransport";
    ConnectionType[ConnectionType["HTTP"] = 1] = "HTTP";
})(ConnectionType || (ConnectionType = {}));
export async function connect(conn_type) {
    if (conn_type == null) {
        const supports_wt = "WebTransport" in window;
        if (supports_wt) {
            const efs = await import("./efs_wt");
            console.log("using webtransport");
            return await efs.connect_wt();
        }
        else {
            const efs = await import("./efs_http");
            console.log("using http");
            return new efs.HttpStream();
        }
    }
    else {
        if (conn_type == ConnectionType.WebTransport) {
            const efs = await import("./efs_wt");
            console.log("using webtransport");
            return await efs.connect_wt();
        }
        else {
            const efs = await import("./efs_http");
            console.log("using http");
            return new efs.HttpStream();
        }
    }
}
